import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SelectedItem } from '../models/table-itens';

@Injectable({
  providedIn: 'root'
})
export class BulkSelectionService {
  private selectedItemsSubject = new BehaviorSubject<SelectedItem[]>([]);
  private applyInBulkSubject = new BehaviorSubject<boolean>(false);

  constructor() { }

  /**
   * Obtém um Observable com os itens selecionados
   */
  public getSelectedItems(): Observable<SelectedItem[]> {
    return this.selectedItemsSubject.asObservable();
  }

  /**
   * Obtém um Observable com o estado atual da aplicação em massa
   */
  public getApplyInBulkState(): Observable<boolean> {
    return this.applyInBulkSubject.asObservable();
  }

  /**
   * Obtém o valor atual dos itens selecionados
   */
  public getCurrentSelectedItems(): SelectedItem[] {
    return this.selectedItemsSubject.getValue();
  }

  /**
   * Obtém o estado atual da aplicação em massa
   */
  public getCurrentApplyInBulkState(): boolean {
    return this.applyInBulkSubject.getValue();
  }

  /**
   * Adiciona ou remove um item da seleção
   * @param item Item a ser adicionado ou removido
   */
  public toggleItem(item: SelectedItem): void {
    const currentItems = this.selectedItemsSubject.getValue();
    const index = currentItems.findIndex(i => 
      i.date === item.date && 
      i.colaboradorId === item.colaboradorId && 
      i.setorId === item.setorId
    );

    if (index !== -1) {
      // Remove o item se já existir
      const newItems = [...currentItems];
      newItems.splice(index, 1);
      this.selectedItemsSubject.next(newItems);
    } else {
      // Adiciona o item se não existir
      this.selectedItemsSubject.next([...currentItems, item]);
    }
  }

  /**
   * Atualiza o estado de aplicação em massa
   * @param state Novo estado
   */
  public updateApplyInBulkState(state: boolean): void {
    this.applyInBulkSubject.next(state);
    
    // Se o estado for falso, limpa os itens selecionados
    if (!state) {
      this.clearSelectedItems();
    }
  }

  /**
   * Alterna o estado de aplicação em massa
   */
  public toggleApplyInBulkState(): void {
    const currentState = this.applyInBulkSubject.getValue();
    this.updateApplyInBulkState(!currentState);
  }

  /**
   * Limpa todos os itens selecionados
   */
  public clearSelectedItems(): void {
    this.selectedItemsSubject.next([]);
  }

  /**
   * Atualiza os itens após aplicação em massa
   * @param updatedItems Itens atualizados
   */
  public updateItemsAfterBulkApply(updatedItems: SelectedItem[]): void {
    // Após aplicação em massa, atualizamos o estado
    this.updateApplyInBulkState(false);
  }
}
